import React from 'react'

const FormSectionDescription = ({ title, text, children }) => (
  <aside className="form-section__description">
    <strong>
      {title}
    </strong>
    <div className="form-section__description-content">
      {children || text}
    </div>
  </aside>
)

export default FormSectionDescription
